import type { ReactNode } from 'react';
import { NetworkCheckingSplash } from './NetworkCheckingSplash';
import { NetworkUnavailableOverlay } from './NetworkUnavailableOverlay';
import { useNetworkStatus } from './NetworkStatusContext';

// Blocks rendering until the first network check resolves, so the login page never
// flashes before we know whether the private network is reachable.
export function NetworkGate({ children }: { children: ReactNode }) {
  const { status, hasConnectedOnce } = useNetworkStatus();

  if (!hasConnectedOnce) {
    return status === 'unavailable' ? (
      <NetworkUnavailableOverlay />
    ) : (
      <NetworkCheckingSplash />
    );
  }

  return (
    <>
      {children}
      <NetworkUnavailableOverlay />
    </>
  );
}
